import * as React from 'react';
import Typography from '@mui/material/Typography';
import {
    Avatar,
    Checkbox,
    FormControlLabel,
    Link,
    Alert,
    TextField,
    Box,
    Divider
} from '@mui/material';
import { LockOutlined } from "@mui/icons-material";
import { Button } from "react-bootstrap";
import "./custom.css"
import { loginUser } from "./UserService";
import { useEffect, useState } from "react";
import { checkUpdateBarcode, getSavedBarcode, getServiceLabel } from "../globalMethods/myConfig";
import BarcodeChecker from "./barcodeChecker";
import config from "../config/config";

const orbitron = "'Orbitron', sans-serif";

const inputSx = {
    mb: 2.5,
    "& .MuiOutlinedInput-root": {
        fontFamily: orbitron,
        fontSize: "0.75rem",
        color: "#fff",
        "& fieldset": { borderColor: "#1565c0" },
        "&:hover fieldset": { borderColor: "#1e88e5" },
        "&.Mui-focused fieldset": { borderColor: "#1e88e5" },
    },
    "& .MuiInputLabel-root": {
        fontFamily: orbitron,
        color: "rgba(255,255,255,0.4)",
        fontSize: "0.75rem",
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#1e88e5" },
};

const GALAXY_BG = `
    linear-gradient(rgba(0,0,0,0.82), rgba(0,0,0,0.88)),
    url('https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=1920&q=80') center/cover no-repeat fixed
`;

const LoginLayout = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [showErrorEmail, setShowErrorEmail] = useState(false);
    const [showErrorPassword, setShowErrorPassword] = useState(false);
    const [imageBarcode, setImageBarcode] = useState("");
    const [barcode, setBarcode] = useState("");

    const handleChangeEmail = (e) => { setEmail(e.target.value); }
    const handleChangePassword = (e) => { setPassword(e.target.value); }


    const [apkVersion, setApkVersion] = useState(null);

    useEffect(() => {
        fetch(`${config.host}app/version/latest`)
            .then(res => res.json())
            .then(data => setApkVersion(data))
            .catch(err => console.log('Version fetch failed', err));
    }, []);

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = `${config.host}app/download`;
        link.setAttribute('download', '');
        document.body.appendChild(link);
        link.click();
        console.log('Download link clicked', link.href);
        document.body.removeChild(link);
    };
    useEffect(() => {
        const checkBarcode = async () => {
            const image = await checkUpdateBarcode()
            setImageBarcode(image)
            const barcode = getSavedBarcode()
            setBarcode(barcode)
        }
        checkBarcode()
    }, [barcode, imageBarcode]);

    return (
        <Box sx={{ minHeight: "100vh", background: GALAXY_BG, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: orbitron, px: 2, py: 6 }}>

            {/* Blue grid overlay */}
            <Box sx={{
                position: "fixed", inset: 0,
                backgroundImage: `linear-gradient(rgba(21,101,192,0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(21,101,192,0.06) 1px, transparent 1px)`,
                backgroundSize: "40px 40px", pointerEvents: "none", zIndex: 0,
            }} />

            <Box sx={{
                position: "relative", zIndex: 1, width: "100%", maxWidth: 460,
                background: "rgba(5,5,15,0.85)", backdropFilter: "blur(16px)",
                border: "1px solid #1565c0", borderRadius: 3, overflow: "hidden",
                boxShadow: "0 0 60px rgba(21,101,192,0.3), 0 0 120px rgba(21,101,192,0.1)",
            }}>
                {/* Blue top bar */}
                <Box sx={{ background: "#1565c0", py: 2, px: 3, display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5 }}>
                    <Avatar sx={{ bgcolor: "#000", width: 32, height: 32 }}>
                        <LockOutlined sx={{ fontSize: 18, color: "#1e88e5" }} />
                    </Avatar>
                    <Typography sx={{ fontFamily: orbitron, fontWeight: 900, fontSize: "0.85rem", letterSpacing: 3, color: "#fff", textTransform: "uppercase" }}>
                        KM-BIZZ · SIGN IN
                    </Typography>
                </Box>

                <Box sx={{ px: 4, pt: 4, pb: 4 }}>
                    <Typography sx={{ fontFamily: orbitron, fontSize: "0.65rem", letterSpacing: 3, color: "#1e88e5", textAlign: "center", mb: 4, textTransform: "uppercase" }}>
                        {getServiceLabel()}
                    </Typography>

                    <TextField
                        error={showErrorEmail}
                        helperText={showErrorEmail ? <label className={'text-field-label'}>This is not an Email</label> : <></>}
                        value={email} onChange={handleChangeEmail}
                        label={<label className={"text-field-label"}>Email</label>}
                        placeholder='Enter Email' type='email' variant="outlined" fullWidth required sx={inputSx}
                    />

                    <TextField
                        error={showErrorPassword}
                        helperText={showErrorPassword ? <label className={'text-field-label'}>This is not a valid Password min 8 Length</label> : <></>}
                        value={password} onChange={handleChangePassword}
                        label={<label className={"text-field-label"}>Password</label>}
                        placeholder='Enter password' type='password' variant="outlined" fullWidth required sx={inputSx}
                    />

                    <FormControlLabel
                        control={<Checkbox name="checkedB" color="primary" sx={{ color: "#1565c0", "&.Mui-checked": { color: "#1e88e5" } }} />}
                        label={<label className={"text-field-label"} style={{ fontFamily: orbitron, fontSize: "0.65rem", color: "rgba(255,255,255,0.5)", letterSpacing: 1 }}>Remember me</label>}
                        sx={{ mb: 3 }}
                    />

                    <Button type='submit'
                            onClick={async () => {
                                const pattern = /.+@.+\..+/
                                if (pattern.test(email) && email.length > 0) {
                                    if (password.length > 8) {
                                        await loginUser(email, password, setMessage, setShowMessage);
                                    } else { setShowErrorPassword(true) }
                                } else {
                                    setShowErrorEmail(true)
                                    if (password.length === 0) { setShowErrorPassword(true) }
                                }
                            }}
                            variant='primary'
                            style={{ width: "100%", background: "#1565c0", border: "none", borderRadius: 6, padding: "12px 0", fontFamily: orbitron, fontWeight: 700, fontSize: "0.75rem", letterSpacing: 3, color: "#fff", textTransform: "uppercase", cursor: "pointer", boxShadow: "0 0 20px rgba(21,101,192,0.5)", marginBottom: 20 }}
                    >
                        SIGN IN
                    </Button>

                    <Divider sx={{ borderColor: "rgba(21,101,192,0.2)", mb: 2.5 }} />

                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                        <Typography sx={{ fontFamily: orbitron, fontSize: "0.6rem", color: "rgba(255,255,255,0.4)", letterSpacing: 1 }}>
                            <Link href="/password-forgotten" sx={{ color: "#1e88e5", textDecorationColor: "#1565c0" }}>Forgot password?</Link>
                        </Typography>
                        <Typography sx={{ fontFamily: orbitron, fontSize: "0.6rem", color: "rgba(255,255,255,0.4)", letterSpacing: 1 }}>
                            No account?&nbsp;<Link href="/sign-up" sx={{ color: "#1e88e5", textDecorationColor: "#1565c0" }}>Sign Up</Link>
                        </Typography>
                    </Box>

                    {showMessage &&
                        <Alert severity="info" sx={{ fontFamily: orbitron, fontSize: "0.65rem", background: "rgba(21,101,192,0.15)", border: "1px solid #1565c0", color: "#fff", mb: 2, "& .MuiAlert-icon": { color: "#1e88e5" } }}>
                            {message}
                        </Alert>
                    }

                    <BarcodeChecker imageBarcode={imageBarcode} barcode={barcode} />

                    {/* APK Download Section */}
                    {apkVersion && (
                        <>
                            <Divider sx={{ borderColor: "rgba(21,101,192,0.2)", mt: 2, mb: 2.5 }} />

                            <Box sx={{
                                border: "1px solid rgba(21,101,192,0.4)",
                                borderRadius: 2,
                                p: 2,
                                background: "rgba(21,101,192,0.07)",
                                backdropFilter: "blur(8px)",
                                position: "relative",
                                overflow: "hidden",
                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0, left: 0, right: 0,
                                    height: "2px",
                                    background: "linear-gradient(90deg, transparent, #1e88e5, transparent)",
                                }
                            }}>
                                {/* Header row */}
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5 }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Box sx={{
                                            width: 28, height: 28, borderRadius: 1,
                                            background: "rgba(21,101,192,0.3)",
                                            border: "1px solid #1565c0",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                            fontSize: "14px"
                                        }}>
                                            📱
                                        </Box>
                                        <Box>
                                            <Typography sx={{
                                                fontFamily: orbitron, fontSize: "0.6rem",
                                                color: "rgba(255,255,255,0.9)", letterSpacing: 2,
                                                textTransform: "uppercase", fontWeight: 700,
                                                lineHeight: 1
                                            }}>
                                                Android App
                                            </Typography>
                                            <Typography sx={{
                                                fontFamily: orbitron, fontSize: "0.55rem",
                                                color: "rgba(255,255,255,0.4)", letterSpacing: 1,
                                            }}>
                                                Streaming
                                            </Typography>
                                        </Box>
                                    </Box>

                                    {/* Version badge */}
                                    <Box sx={{
                                        px: 1.2, py: 0.4,
                                        background: "rgba(21,101,192,0.25)",
                                        border: "1px solid #1565c0",
                                        borderRadius: 1,
                                    }}>
                                        <Typography sx={{
                                            fontFamily: orbitron, fontSize: "0.55rem",
                                            color: "#1e88e5", letterSpacing: 1, fontWeight: 700
                                        }}>
                                            v{apkVersion.version}
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Release notes if present */}
                                {apkVersion.releaseNotes && (
                                    <Typography sx={{
                                        fontFamily: orbitron, fontSize: "0.55rem",
                                        color: "rgba(255,255,255,0.35)", letterSpacing: 0.8,
                                        mb: 1.5, lineHeight: 1.6,
                                        borderLeft: "2px solid #1565c0",
                                        pl: 1
                                    }}>
                                        {apkVersion.releaseNotes}
                                    </Typography>
                                )}

                                {/* Download button */}

                                <Typography sx={{ fontFamily: orbitron, fontSize: "0.6rem", textAlign: "center", mt: 1 }}>
                                    <Link href="/download" sx={{ color: "#1e88e5", textDecorationColor: "#1565c0" }}>
                                        📱 Download Android App
                                    </Link>
                                </Typography>

                                {/* Bottom meta info */}
                                <Box sx={{ display: "flex", justifyContent: "center", mt: 1.2 }}>
                                    <Typography sx={{
                                        fontFamily: orbitron, fontSize: "0.5rem",
                                        color: "rgba(255,255,255,0.25)", letterSpacing: 1
                                    }}>
                                        ANDROID · APK · CANAL+
                                    </Typography>
                                </Box>
                            </Box>
                        </>
                    )}
                </Box>

            </Box>


        </Box>
    );
}

export default LoginLayout;
